import { Box, Flex, useDisclosure, useMediaQuery } from "@chakra-ui/react";
import { createContext } from "react";
import DashBoard from "../../pages/Sidebar";
import Page from "./Page";
import MobileSidebar from "./MobileSideBar";

export const NavContext = createContext<any>(null);

const Layout = ({ children }: any) => {
  const sidebarState: {
    isOpen: boolean;
    onOpen: () => void;
    onClose: () => void;
    onToggle: () => void;
    isControlled: boolean;
    getButtonProps: (props?: any) => any;
    getDisclosureProps: (props?: any) => any;
  } = useDisclosure();

  const [isLargeScreen] = useMediaQuery(`(min-width: 768px)`);

  return (
    <Box h={"100vh"}>
      <NavContext.Provider value={sidebarState}>
        <Flex gap={{ md: ".5rem", lg: "2rem" }}>
          {isLargeScreen ? <DashBoard /> : <MobileSidebar />}
          <Page>{children}</Page>
        </Flex>
      </NavContext.Provider>
    </Box>
  );
};

export default Layout;
